export default __webpack_public_path__ + "static/media/logo3.1042d318.svg";